<div class="search--bar form" [formGroup]="searchForm">
  <div class="search--bar__icon">
    <i class="icon icon-ui-search"></i>
  </div>
  <input
    id="search-query"
    class="search--bar__input"
    type="text"
    name="query"
    (focus)="onFocus()"
    (blur)="onBlur()"
    (input)="onInput()"
    (keydown)="onKeyDown($event)"
    formControlName="query"
    autocomplete="off"
    [placeholder]="placeholder ?? 'general.search.placeholder' | translate"
    [disabled]="searchDisabled"
  />
  <button
    *ngIf="searchForm.controls.query.value"
    class="search--bar__cancel d--none--sm"
    type="button"
    (click)="onClose(userEventAction.cancel)"
  >
    <i class="icon icon-ui-close--sm"></i>
  </button>
  <button *ngIf="hasInput" class="search--bar__cancel d--none d--block--sm" type="button" (click)="onCancel(true)">
    <i class="icon icon-ui-close--sm"></i>
  </button>
</div>
<button *ngIf="!static" class="search--bar__close d--none d--block--sm" type="button" (click)="onClose(userEventAction.close)">
  <i class="icon icon-ui-close--sm"></i>
</button>
